import { variables } from "../../styles";
const {
    borderRadius,
    borderWidthThin,
    borderWidthMedium,
    imageThumbSize,
    marginHorizontal,
    marginVertical,
    paddingHorizontal,
    paddingVertical,
} = variables;

const PHOTO_SIZE = window.outerWidth;

export default (theme) => ({
    padding: {
        padding: `${theme.spacing(2)} 0`,
    },
    modal: {
        backgroundColor: theme.palette.primary.lightBackground,
        padding: theme.spacing(2),
    },
    photo: {
        width: PHOTO_SIZE,
        height: PHOTO_SIZE,
        objectFit: "cover",
    },
    previewWrp: {
        paddingTop: theme.spacing(2),
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        borderTop: `1px solid ${theme.palette.primary.lightBorder}`,
    },
    imagePreview: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
    },
    listWrp: {
        overflowY: "scroll",
        display: "flex",
        width: "100%",
        borderBottom: `${borderWidthThin}px solid ${theme.palette.border.lightBorder}`,
        padding: `0 ${theme.spacing(1)}`,
        paddingBottom: paddingVertical,
    },
    photoList: {
        margin: `${theme.spacing(2)} 0`,
    },
    photoListItemImage: {
        backgroundColor: theme.palette.background.mediumBackground,
        borderRadius,
        borderColor: theme.palette.border.priamry,
        borderWidth: borderWidthMedium,
        marginRight: marginHorizontal,
        width: imageThumbSize,
        height: imageThumbSize,
        objectFit: "cover",
    },
    menuItem: {
        textTransform: "capitalize",
    },
});
